import { TAddFavoriteResponseError, IAddFavoriteResponse400 } from '../../../../repositories/favorites/v1/add-favorite';

export const mapAddFavoriteResponseError = (response: TAddFavoriteResponseError): IAddFavoriteResponse400 => {
  return {
    statusCode: 400,
    headers: [],
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
};
